import { useState, useEffect, useContext } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import SideLogin from './sideLogin.js';
import {EmailSent, RequestResetPassword, ResetPasswordNew} from './ResetPassword';
import SignIn from './SignIn.js';
import { Topbar, } from './NestingApp.js';
import { nestingLoader, NestingApp } from './Nesting.js';
import { UserContext, FetchContext, NestingContext } from './context.js';
import { createNesting } from "./nestingList.js";
import './App.css';
import { createBrowserRouter, RouterProvider, redirect, Outlet, Navigate } from "react-router-dom";
import { useNwsFetch } from './customFetch';
import nwsFetch from './customFetch';
import {PageCentered} from "./style.js";

const theme = createTheme({
  palette: {
    primary: {
      light: '#88CCEE',
      main: '#44AA99',
      dark: '#117733',
      contrastText: '#fff',
    },
    secondary: {
      light: '#DDCC77',
      main: '#CC6677',
      dark: '#AA4499',
      contrastText: '#000',
    },
    error: {
      main: '#882255',
    },
    success: {
      main: '#44AA99',
    },
  },
});

async function getUser(){
	const request = await fetch("/accounts/api/whoami/");
	return await request.json();
}

function ProtectedLayout({children}){
	const user = useContext(UserContext)[0];
	const [nesting, setNesting] = useState(false);
  const [nwsFetch, error] = useNwsFetch();
	if(user.unChecked){
		return (
			<Box sx={{ display: 'flex' }}>
				<CircularProgress />
			</Box>
		);
	}else if(!user.unChecked && !user.authenticated){
		return <Navigate to="/login" />;
	}else{
		return (
			<>
        <FetchContext.Provider value={ nwsFetch }>
        <NestingContext.Provider value={ [nesting, setNesting] }>
          <Topbar/>
          <Outlet/>
        </NestingContext.Provider>
        </FetchContext.Provider>
        {error}
			</>
		)
	}
}

async function getOrCreateNesting(){
  const defaultNesting = localStorage.getItem("default_nesting");
  if(defaultNesting){
	  const request = await fetch("/api/groups/"+defaultNesting);
    if(request.ok){
      const nesting = await request.json();
      return [true, nesting];
    }
  }
	const request = await fetch("/api/groups/");
	if(!request.ok){
		// never create a nesting when the list could not be read
		if(request.status === 401 || request.status === 403){
			return [false, null];
		}
		throw new Response("Could not load nestings", {status: request.status});
	}
	const page = await request.json();
	if(page.count > 0){
		// the latest nesting
		return [true, page.results[0]];
	}else{
		return await createNesting(nwsFetch);
	}
}

export async function defaultNestingLoader(){
	const [ok, nesting] = await getOrCreateNesting();
	if(ok){
		throw redirect("/nesting/" + nesting.slug);
	}else{
		throw redirect("/login/");
	}
}

function Layout({children}){
  return (
    <PageCentered direction="column">
      <PageCentered>
        {children}
      </PageCentered>
    </PageCentered>
  )
}


const router = createBrowserRouter([{
	path: "/",
	children: [
		{
			element: <ProtectedLayout/>,
			children: [
				{
					index: true,
					loader: defaultNestingLoader,
				}, {
					loader: nestingLoader,
					path: "nesting/:nestingSlug",
					element: <NestingApp/>,
				}
			]
		}, {
			path: "login",
			element: <Layout><SideLogin/></Layout>,
		}, {
			path: "signup",
			element: <Layout><SignIn/></Layout>,
		}, {
			path: "reset_password",
			element: <Layout><RequestResetPassword/></Layout>,
		}, {
			path: "email_sent",
			element: <Layout><EmailSent/></Layout>,
		}, {
			path: "reset_new_password/:uid/:token",
			element: <Layout><ResetPasswordNew /></Layout>,
		}
	]
}],{
  basename: process.env.REACT_APP_BASENAME, 
});

function App() {
	const [user, _setUser] = useState({
		unChecked: true,
		authenticated: false,
		username: "Unknown",
	});
	function setUser(user){
		user.unChecked = false;
		_setUser(user);
	}
	useEffect(() => {
		getUser().then((user) => {
			setUser(user);
		});
	}, [] );
	return (
		<ThemeProvider theme={theme}>
			<UserContext.Provider value={ [user, setUser] }>
				<div className="App">
					<RouterProvider router={router} />
				</div>
			</UserContext.Provider >
		</ThemeProvider>
	)
}

export default App;
